import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformXAxis'
})
export class TransformXAxisPipe implements PipeTransform {

  transform(xValues: number[], yValues: number[], threshold: number,positiveLimit: number): { range: [number, number] } {
    const filteredX: number[] = [];
    for (let i = 0; i < yValues.length; i++) {
      if (yValues[i] !== 0 && xValues[i] >= 0 && xValues[i] < positiveLimit) {
        filteredX.push(xValues[i]);
      }
    }
    const minX = Math.min(...filteredX);
    const maxX = Math.max(...filteredX);
    return { range: [minX - threshold, maxX + threshold] };
  }

  filterYValues(xValues: number[], yValues: number[], threshold: number,positiveLimit: number): { range: [number, number] } {
    const filteredY: number[] = [];
    for (let i = 0; i < xValues.length; i++) {
      if (xValues[i] !== 0  && xValues[i] < positiveLimit) {
        filteredY.push(yValues[i]);
      }
    }
    const minX = Math.min(...filteredY);
    const maxX = Math.max(...filteredY);
    return { range: [minX - threshold, maxX + threshold] };
  }

}
